import React from 'react'

function Contact() {
  return (
    <section className="cont__contact">
        <p>Let's create something new</p>
        <h3>LET`S GET IN <em>TOUCH</em></h3>
        <a href="/">contact</a>
    </section>
  )
}

export default Contact